module.exports = __webpack_public_path__ + "static/media/about.a177dd70.jpg";